<template>
  <div class="hhxc-logo">
    <img src="@/assets/images/logo-white-2.png" />
    <!-- <span class="anticon"></span> -->
    <!-- <span>{{ title }}</span> -->
  </div>
</template>

<script>
  import { computed } from 'vue'
  import { useStore } from 'vuex'

  export default {
    name: 'HhxcLogo',
    setup() {
      const store = useStore()
      return {
        title: computed(() => store.getters['settings/title']),
      }
    },
  }
</script>
<style lang="less" scoped>
  .hhxc-logo {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 32px;
    margin: 10px 5px;
    overflow: hidden;
    overflow: hidden;
    font-size: 15px;
    color: #fff;
    text-overflow: ellipsis;
    white-space: nowrap;
    img {
      // width: 24px;
      width: 100%;
      // height: 24px;
    }
  }
</style>
